module.exports = __webpack_public_path__ + "xml/kfz24/browserconfig.xml";